const mediaItems = [
  {
    id: 1,
    title: '《暗夜追踪》终极预告',
    desc: '年度悬疑犯罪大片，高智商对决层层反转，IMAX 特制画幅呈现极致视觉冲击。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20scene%20with%20dark%20rainy%20city%20street%20at%20night%20neon%20reflections%20on%20wet%20pavement%2C%20mysterious%20silhouette%20under%20streetlamp%2C%20film%20noir%20atmosphere%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=800&height=450&seq=media-01-beiwo&orientation=landscape',
    tag: '悬疑',
  },
  {
    id: 2,
    title: '《星际迷途：新纪元》',
    desc: '硬核科幻史诗重启，外星文明与人类命运的终极碰撞，视觉特效全面升级。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20spacescape%20with%20massive%20starship%20drifting%20through%20colorful%20nebula%20clouds%2C%20distant%20planets%20visible%2C%20warm%20cosmic%20dust%20glowing%20in%20amber%20and%20gold%20hues%2C%20cinematic%20widescreen%20composition&width=800&height=450&seq=media-02-beiwo&orientation=landscape',
    tag: '科幻',
  },
  {
    id: 3,
    title: '《长安十二味》纪录片',
    desc: '穿越千年古都的美食之旅，用镜头记录烟火人间最温暖的味觉记忆。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20traditional%20Chinese%20kitchen%20scene%20with%20steaming%20food%20on%20wooden%20table%2C%20soft%20golden%20lantern%20lighting%2C%20clay%20pots%20and%20ceramic%20bowls%2C%20rich%20earthy%20amber%20and%20red%20tones%2C%20documentary%20photography%20style&width=800&height=450&seq=media-03-beiwo&orientation=landscape',
    tag: '纪录',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-2">Media Preview</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            影视速看
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            精选最新预告与精彩片段，不错过每一部值得期待的好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 transition-all duration-300 hover:border-accent-300/40 cursor-pointer">
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500/90 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs font-medium rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap overflow-hidden text-ellipsis" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}